export default function styles() {
  return {
    column: {
      textTransform: 'capitalize',
    },
  }
}
